import { render, staticRenderFns } from "./CorporationA.vue?vue&type=template&id=53c1b974&scoped=true"
import script from "./CorporationA.vue?vue&type=script&lang=js"
export * from "./CorporationA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c1b974",
  null
  
)

export default component.exports